<div class="container">
  <div class="row">
    <div class="content">
      <div class="box-text d-flex">
        <span class="material-icons">
          block
        </span>
        <p>
          {{data}}
        </p>
      </div>
      <span class="material-icons" (click)="closeSnackBar()">
        close
      </span>

    </div>
  </div>
</div>